import { Grid, Typography, Skeleton } from "@mui/material";
import { fCurrency } from "../../utils/formatNumber";
import { fMonthDayYearSlashNotation } from "../../utils/formatTime";
import { useOrderInfo } from "../../shared/orderInfo/OrderInfoContext";
import StatusAndDate from "./StatusAndDate";

const Order = () => {
  const orderInfo = useOrderInfo();

  const captionSx = { fontSize: { xs: "0.7rem", lg: "0.75rem" } };
  const subtitle1Sx = { fontSize: { xs: "0.85rem", lg: "1rem" } };

  return (
    <Grid
      className="customCard"
      container
      width={320}
      columnSpacing={3}
      rowSpacing={1}
      sx={{
        ml: 0,
        ".MuiTypography-caption": { lineHeight: "0.7rem" },
        "> .MuiGrid-item": { paddingLeft: "0px" },
        "> .MuiGrid-item:nth-child(odd)": { paddingLeft: "0px", paddingRight: "12px" }
      }}
    >
      <Grid item xs={6} style={{ paddingTop: 0 }}>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {orderInfo?.propertyUse} {!orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      <Grid item xs={6} style={{ paddingTop: "0px" }}>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {orderInfo?.transactionType}
          {!orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      {orderInfo?.commitmentDate && (
        <Grid item xs={6}>
          <Typography variant="caption" sx={captionSx}>
            Commitment Date
          </Typography>
          <Typography variant="subtitle1" sx={subtitle1Sx}>
            {orderInfo?.commitmentDate && fMonthDayYearSlashNotation(orderInfo?.commitmentDate)}
            {!orderInfo && <Skeleton />}
          </Typography>
        </Grid>
      )}
      {(orderInfo?.status || orderInfo?.settlementDate) && (
        <Grid item xs={6}>
          {orderInfo && <StatusAndDate order={orderInfo} />}
          {!orderInfo && <Skeleton />}
          {!orderInfo && <Skeleton />}
        </Grid>
      )}
      <Grid item xs={6}>
        <Typography variant="caption" sx={captionSx}>
          Purchase Price
        </Typography>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {orderInfo && fCurrency(orderInfo?.salesPrice || 0)}
          {!orderInfo && <Skeleton />}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="caption" sx={captionSx}>
          Loan Amount
        </Typography>
        <Typography variant="subtitle1" sx={subtitle1Sx}>
          {(orderInfo && orderInfo?.loanAmounts.map((l) => fCurrency(l)).join(", ")) || (orderInfo && "--")}
          {!orderInfo && <Skeleton />}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Order;
